import EventBus from './Event';

class RepeaterFields {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.groupsName = this.$el.data('field-group-name');
    this.$groups = this.$el.find('[data-field-group-index]');
    this.$groupTpl = this.$groups.first().clone();
    this.$summaries = this.$el.find('[data-field-group-summary]');
    this.$actionSave = this.$el.find('[data-field-group-action="save"]');
    this.$actionAdd = this.$el.find('[data-field-group-action="add"]');
    this.$actionDelete = this.$el.find('[data-field-group-action="delete"]');

    this.groupsCount = this.$groups.length;

    this.$summaries.hide();
    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  bindEvents() {
    this.$el.on('click', '[data-field-group-action="add"]', this.onClickAdd.bind(this));
    this.$el.on('click', '[data-field-group-action="save"]', this.onClickSave.bind(this));
    this.$el.on('click', '[data-field-group-action="delete"]', this.onClickDelete.bind(this));
    this.$el.on('click', '[data-field-group-summary]', this.onClickSummary.bind(this));

    EventBus.on('prequalification:add-group', this.addFieldGroup.bind(this));
    EventBus.on('prequalification:validation-error', this.onValidationError.bind(this));
  }

  onClickAdd(e) {
    e.preventDefault();
    e.stopPropagation();

    this.addFieldGroup();
    $(e.currentTarget).hide();
  }

  addFieldGroup(groupName = '') {
    if (groupName && groupName !== this.groupsName) {
      return;
    }

    const $newGroup = this.$groupTpl.clone();
    this.groupsCount++;
    $newGroup.attr('data-field-group-index', this.groupsCount);
    $newGroup.find('[data-field-group-summary]').attr('data-field-group-summary', this.groupsCount);
    $newGroup.find('input, select, textarea, hidden').each((i, current) => {
      // create attributes for new input
      const $current = $(current);
      const copiedKey = $current.attr('name');
      const newKey = copiedKey.slice(0, copiedKey.length - 1) + `${this.groupsCount}`;
      const initialId = $current.attr('id');
      const newId = `${initialId}_${this.groupsCount}`;

      // update new input with new attributes
      if ($current.attr('type') === 'radio' || $current.attr('type') === 'checkbox') {
        $current.prop('checked', false);
      } else {
        $current.val('');
      }
      $current
        .attr('name', newKey)
        .attr('id', newId)
        .attr('data-name', newKey)
        .attr('required', false)
      $current.closest('[data-fields-group-form]').find(`[for="${initialId}"]`).attr('for', newId);
    });
    
    // render new group, and update UI
    this.$groups.last().after($newGroup);
    this.$groups = this.$el.find('[data-field-group-index]');
    if (this.groupCount > 1) $newGroup.prev().find('[data-field-group-action="add"]').hide();
    this.toggleFieldGroupSummaryMode($newGroup, true);
    
    // emit event to initialize fields
    const eventName = groupName ? 'repeater-fields:loaded' : 'repeater-fields:added';
    console.log('eventName: ', eventName);
    EventBus.emit(eventName, $newGroup);
    if (initializeAutocomplete && grapp.environment !== 'development') {
      initializeAutocomplete();
    }
  }

  onClickSave(e) {
    e.preventDefault();
    const $currentFieldGroup = $(e.target).closest('[data-field-group-index]');
    const $currentSummary = $currentFieldGroup.find('[data-field-group-summary]');
    const $summaryTitleField = $currentFieldGroup.find('[data-field-group-summary-title]');
    const $summaryTextFields = $currentFieldGroup.find('[data-field-group-summary-text]');
    const summaryTextValues = $summaryTextFields.map((i, el) => {
        const $el = $(el);
        if ($el.attr('type') === 'radio' || $el.attr('type') === 'checkbox') {
          if ($el.prop('checked')) {
            const label = $el.siblings('.form_radio_label').text();
            return label;
          }
          return '';
        }
        if ($el.attr('type') === 'select') {
          return $el.find('option:selected').text();
        }
        return $el.val();
      }
    ).get();

    // @TODO: update selector to use data attribute
    $currentSummary.find('.form_group_toggle_title').text($summaryTitleField.val());
    const summaryText = this.getGroupSummary($currentFieldGroup);
    $currentSummary.find('.form_group_toggle_summary').text(summaryText); 
    this.toggleFieldGroupSummaryMode($currentFieldGroup);

    // scroll to top of $currentSummary
    $('html, body').animate({ scrollTop: $currentSummary.offset().top }, 200);
  }

  getGroupSummary($currentFieldGroup) {
    const summaryTextData = {  
      'address': {
        fieldNames: [
          'preq_start_month_', 'preq_start_year_', 'preq_end_month_', 'preq_end_year_'
        ],
        getSummaryText: (fieldNames) => {
          const startMonth = $currentFieldGroup.find(`[name^="${fieldNames[0]}"] option:selected`).text();
          const startYear = $currentFieldGroup.find(`[name^="${fieldNames[1]}"] option:selected`).text();
          const endMonth = $currentFieldGroup.find(`[name^="${fieldNames[2]}"] option:selected`).text();
          const endYear = $currentFieldGroup.find(`[name^="${fieldNames[3]}"] option:selected`).text();

          if (endMonth === 'Present' || endYear === 'Present') {
            return `${startMonth} ${startYear} - Present`;
          }

          return `${startMonth} ${startYear} - ${endMonth} ${endYear}`;
        }
      },
      'employer': {
        fieldNames: [
          'preq_employer_paycheck_', 'preq_employment_pay_freq_'
        ],
        getSummaryText: (fieldNames) => {
          const paycheck = $currentFieldGroup.find(`[name^="${fieldNames[0]}"]`).val();
          const payFreq = $currentFieldGroup.find(`[name^="${fieldNames[1]}"] option:selected`).text();
          return `${paycheck} ${payFreq}`;
        }
      },
      'income': {
        fieldNames: [
          'preq_income_amount_', 'preq_income_freq_'
        ],
        getSummaryText: (fieldNames) => {
          const income = $currentFieldGroup.find(`[name^="${fieldNames[0]}"]`).val();
          const incomeFreq = $currentFieldGroup.find(`[name^="${fieldNames[1]}"] option:selected`).text();
          return `${income} ${incomeFreq}`;
        }
      },
    };

    const groupName = this.$el.data('field-group-name');
    const summaryData = summaryTextData[groupName];
    if (!summaryData) {
      console.log('No summary data found for group name: ', groupName);
      return '';
    }
    const fields = summaryData.fieldNames;
    return summaryData.getSummaryText(fields);
  }

  onClickDelete(e) {
    e.preventDefault();
    e.stopPropagation();
    // return if there is only one group
    if (this.groupsCount === 1) {
      return;
    }
    // return if it is the initial group
    if ($(e.target).closest('[data-field-group-index]').is(':first-child')) {
      return;
    }

    const $currentFieldGroup = $(e.target).closest('[data-field-group-index]');
    $currentFieldGroup.remove();
    this.groupsCount--;

    // get 'add' buttons and show the one in the last group
    const $addButtons = this.$el.find('[data-field-group-action="add"]');
    $addButtons.last().show();

    this.$groups = this.$el.find('[data-field-group-index]');
    this.$el.find('[data-field-group-action="add"]').hide();
    this.$groups.last().find('[data-field-group-action="add"]').show();

    EventBus.emit('repeater-fields:deleted');
  }

  onClickSummary(e) {
    const $fieldGroup = $(e.target).closest('[data-field-group-index]');
    this.toggleFieldGroupSummaryMode($fieldGroup);
  }

  onValidationError() {
    console.log('onValidationError');
    const $errors = this.$el.find('.form_error_message');
    if ($errors.length) {
      const $errorFieldGroup = $errors.closest('[data-field-group-index]');
      this.toggleFieldGroupSummaryMode($errorFieldGroup, true);
    }
  }

  toggleFieldGroupSummaryMode($fieldGroup, force) {
    const $summary = $fieldGroup.find('[data-field-group-summary]');
    const summaryIndex = $summary.data('field-group-summary');
    const $fields = $fieldGroup.find('[data-fields-group-form]');

    if (force === undefined) {
      $fields.toggle();
    } else {
      $fields.toggle(force);
    }
    // if summary is visible, hide it
    if ($fields.css('display') !== 'none') {
      $summary.hide();
      $summary.find('[data-field-group-action="add"]').hide();
    } else {
      $summary.show();
    }

    this.$el.find('[data-field-group-action="add"]').hide();
    this.$groups.last().find('[data-field-group-action="add"]').show();
  }

  static init() {
    $('[data-js-component="repeater-fields"').each((i, el) => new RepeaterFields(el));
  }
}

RepeaterFields.init();
